const initFadeInAnimations = () => {
  if (!window.gsap || !window.ScrollTrigger) return;
  
  gsap.registerPlugin(ScrollTrigger);
  
  // Defer layout reads to avoid forced reflow
  requestAnimationFrame(() => {
    const isMobile = window.innerWidth < 768;
    const isDesignMode = window.Shopify?.designMode;
    
    document.querySelectorAll('[data-fade-in]').forEach(element => {
      // Only run animations on desktop (>=768px) or in theme editor
      if (isMobile || isDesignMode) {
        gsap.set(element, {
          opacity: 1,
          x: 0
        })
        
        return; 
      };

      const delayValue = element.getAttribute('data-fade-in') !== '' 
        ? parseFloat(element.getAttribute('data-fade-in')) * 0.1 
        : 0;
      
      gsap.to(element, {
        opacity: 1,
        x: 0,
        duration: 0.4,
        ease: 'power3.out',
        delay: delayValue,
        scrollTrigger: {
          trigger: element,
          start: 'top 90%',
          once: true
        }
      });
    });
  });
};

// The theme editor re-renders sections without a page load, and new elements start hidden.
document.addEventListener('shopify:section:load', initFadeInAnimations);

// Wait for GSAP to load
const checkGSAPFadeIn = setInterval(() => {
  if (window.gsap && window.ScrollTrigger) {
    clearInterval(checkGSAPFadeIn);
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFadeInAnimations);
    } else {
      initFadeInAnimations();
    }
  }
}, 50);

// Timeout after 5 seconds. Without the libraries nothing would ever reveal these elements.
setTimeout(() => {
  clearInterval(checkGSAPFadeIn);

  if (!window.gsap || !window.ScrollTrigger) {
    document.querySelectorAll('[data-fade-in]').forEach(element => {
      element.style.opacity = 1;
      element.style.transform = 'none';
    });
  }
}, 5000);